<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13kbMBv/tc-custom/9781943858200.jpg?1696025452361" alt="This image is the cover for the book One S'more Summer, The Campfire Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One S'more Summer, The Campfire Series
      </h1>
      <p class="bookDescription body article font2">
        <b>"If HBO’s <i>Girls</i> went to summer camp, this would be their story. A fast-paced, enjoyable read!" -- Kristin Harmel, international bestselling author of <i>The Sweetness of Forgetting</i></b><br/><br/>For twenty long years, Gigi Goldstein has been pining away for her best friend’s guy. She knows it’s wrong and it has to stop, but she hasn’t been able to let go ever since they all met on the bus to summer camp back when they were seven years old. The same week that her best friends finally announce their wedding date, Gigi loses her high-profile design job. With all of her dreams unravelling, she runs to the last place she remembers being happy. <br/><br/>Taking the Head Counselor position at Camp Chinooka, Gigi hopes to reclaim the joy she felt as a camper, but the job isn’t all campfire songs and toasting marshmallows. Gigi’s girls are determined to make her look bad in front of the boys’ Head Counselor—the sexy but infuriating Perry—and every scrap of the campground is laced with memories. <br/><br/>When Gigi finally realizes she can’t escape the present by returning to her past, she’s forced to reexamine her life and find the true meaning of love. But will she be able to mend fences and forgive herself before she loses her one real shot at happiness? <br/><br/> <b><i>If you love Sophie Kinsella and Emily Giffin, you'll love this heartwarming debut from a fresh voice in contemporary chick-lit that offers a lighthearted and fun take on friendship, love, and how to recover from past mistakes.</i><br/><br/> The Campfire Series</b><br/> 1. One S’more Summer<br/> 2. S'more to Lose<br/> 3. Love You S'more<br/> 4. Tell Me S’more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Merlin
      </h2>
      
      <p class="authorDescription body article">Beth Merlin has a BA from The George Washington University where she minored in Creative Writing and a JD from New York Law School. She’s a native New Yorker who loves anything Broadway, her beautiful daughter, and a good maxi dress. She was introduced to her husband through a friend she met at sleepaway camp and considers the eight summers she spent there to be some of the most formative of her life. When Beth finds a moment of free time, she loves to read books by the authors who've most influenced her work, like Sophie Kinsella, Emily Giffin, and JoJo Moyes.<br><br><i>One S’more Summer</i> is Beth's debut novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ink Monster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39276f84